import React, { useState, useEffect } from 'react';
import JobListingForm from '../components/JobListingForm';
import API_BASE from '../utils/apiBase';

const AdminJobForm = () => {
  const [refresh, setRefresh] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState(null);
  const [status, setStatus] = useState('');

  useEffect(() => {
    setLoading(true);
    fetch(`${API_BASE}/api/jobs.php`)
      .then(res => res.json())
      .then(data => {
        setJobs(data.jobs || []);
        setLoading(false);
      });
  }, [refresh]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this job?')) return;
    setStatus('Deleting...');
    await fetch(`${API_BASE}/api/delete_job.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `id=${id}`
    });
    setRefresh(r => !r);
    setStatus('');
  };

  const handleEdit = (job) => {
    setEditId(job.id);
    setEditForm({ ...job });
  };

  const handleEditChange = e => {
    const { name, value } = e.target;
    setEditForm(prev => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = async e => {
    e.preventDefault();
    setStatus('Saving...');
    await fetch(`${API_BASE}/api/add_job.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...editForm, id: editId })
    });
    setEditId(null);
    setEditForm(null);
    setRefresh(r => !r);
    setStatus('');
  };

  return (
    <div className="max-w-4xl mx-auto py-8" style={{ marginTop: "90px" }}>
      <JobListingForm onJobAdded={() => setRefresh(r => !r)} />
      <div className="mt-12">
        <h2 className="text-xl font-bold mb-4 text-blue-700">Posted Jobs</h2>
        {loading ? (
          <div className="text-blue-400">Loading...</div>
        ) : jobs.length === 0 ? (
          <div className="text-gray-400">No jobs posted yet.</div>
        ) : (
          <div className="space-y-4">
            {/* Headings Row - only show if jobs exist */}
            {jobs.length > 0 && (
              <div className="hidden md:flex bg-blue-100 rounded-t-xl px-4 py-2 font-semibold text-blue-900 text-sm border border-blue-200">
                <div className="w-32">Title</div>
                <div className="w-32">Qualification</div>
                <div className="w-32">Experience</div>
                <div className="w-20">Positions</div>
                <div className="flex-1">Description</div>
                <div className="w-32 text-center">Actions</div>
              </div>
            )}
            {jobs.map(job => (
              <div key={job.id} className="bg-blue-50 rounded-xl p-4 flex flex-col md:flex-row md:items-center md:justify-between border border-blue-200 shadow">
                {editId === job.id ? (
                  <div className="w-full">
                    <div className="hidden md:flex font-semibold text-blue-900 text-xs mb-1 px-1">
                      <div className="w-32">Title</div>
                      <div className="w-32">Qualification</div>
                      <div className="w-32">Experience</div>
                      <div className="w-20">Positions</div>
                      <div className="flex-1">Description</div>
                      <div className="w-32 text-center">Actions</div>
                    </div>
                    <form onSubmit={handleEditSubmit} className="flex-1 flex flex-col md:flex-row md:items-center gap-2">
                      <input name="title" value={editForm.title} onChange={handleEditChange} className="px-2 py-1 border rounded w-32" />
                      <input name="qualification" value={editForm.qualification} onChange={handleEditChange} className="px-2 py-1 border rounded w-32" />
                      <input name="experience" value={editForm.experience} onChange={handleEditChange} className="px-2 py-1 border rounded w-32" />
                      <input name="positions" type="number" min="1" value={editForm.positions} onChange={handleEditChange} className="px-2 py-1 border rounded w-20" />
                      <textarea name="description" value={editForm.description} onChange={handleEditChange} className="px-2 py-1 border rounded flex-1 min-w-[120px]" />
                      <button type="submit" className="bg-blue-600 text-white px-3 py-1 rounded">Save</button>
                      <button type="button" onClick={() => setEditId(null)} className="bg-gray-300 px-3 py-1 rounded">Cancel</button>
                    </form>
                  </div>
                ) : (
                  <>
                    <div className="flex-1 md:flex md:items-center md:gap-2">
                      <div className="w-32 font-semibold text-blue-800 text-base md:text-sm truncate">{job.title}</div>
                      <div className="w-32 text-xs text-blue-900 truncate">{job.qualification}</div>
                      <div className="w-32 text-xs text-blue-900 truncate">{job.experience}</div>
                      <div className="w-20 text-xs text-blue-900">{job.positions}</div>
                      <div className="flex-1 text-xs text-gray-700 truncate">{job.description}</div>
                    </div>
                    <div className="flex gap-2 mt-2 md:mt-0 w-32 justify-center">
                      <button onClick={() => handleEdit(job)} className="bg-yellow-400 hover:bg-yellow-500 text-white px-3 py-1 rounded">Edit</button>
                      <button onClick={() => handleDelete(job.id)} className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded">Delete</button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
        {status && <div className="text-center text-blue-700 mt-2">{status}</div>}
      </div>
    </div>
  );
};

export default AdminJobForm;
